import {
  FOC_REQUIRED_DISPOSITION,
  IOC_CARRYOVER_DISPOSITION,
} from '../orgWorkspaceTour/orgWorkspaceTourSteps';

export { FOC_REQUIRED_DISPOSITION, IOC_CARRYOVER_DISPOSITION };

export const FOC_POTENTIAL_DISPOSITION =
  'FOC Potential — Government Decision Required';

export type FocResTourStepDef = {
  id: string;
  requirementId?: string;
  title: string;
  disposition?: string;
  description: string;
  bullets?: string[];
  tour?: string;
  /** Hub Resources surface for prepare bridge. */
  surface?: 'assets' | 'requests' | 'ics211' | 'activityLog';
  /**
   * How long to wait for the target after preparing the step, when it needs a
   * page to load.
   */
  waitMs?: number;
};

export type RequirementInput = Omit<
  FocResTourStepDef,
  'title' | 'requirementId'
> & {
  requirementId: string;
  name: string;
};

export function requirement({
  requirementId,
  name,
  ...rest
}: RequirementInput): FocResTourStepDef {
  return {
    ...rest,
    requirementId,
    title: `${requirementId} — ${name}`,
  };
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export function focResTourPopoverHtml(
  step: Pick<FocResTourStepDef, 'disposition' | 'description' | 'bullets'>
): string {
  const body = `<p>${escapeHtml(step.description)}</p>`;
  const bullets = step.bullets?.length
    ? `<ul>${step.bullets
        .map((bullet) => `<li>${escapeHtml(bullet)}</li>`)
        .join('')}</ul>`
    : '';
  const content = `${body}${bullets}`;
  if (!step.disposition) return content;
  return `<p><strong>Disposition:</strong> ${escapeHtml(step.disposition)}</p>${content}`;
}
